// Grab all .svg files
const req = require.context('/public/assets/svg', false, /\.svg$/)

const icons = req.keys().reduce((acc, filePath) => {
  const name = filePath.replace('./', '').replace('.svg', '')
  acc[name] = req(filePath).default
  return acc
}, {} as Record<string, React.FC<React.SVGProps<SVGSVGElement>>>)

type IconName = keyof typeof icons

type DynamicIconProps = {
  name: IconName
}

const DynamicIcon = ({ name }: DynamicIconProps) => {
  const Icon = icons[name]
  if (!Icon) {
    console.error(`DynamicIcon: no icon found for "${name}"`)
    return null
  }
  return <Icon />
}

export default DynamicIcon
